$(document).ready(function() {

  $('.js-tooltip-item').each(function() {
    const $this = $(this),
          tooltip = $this.find('.js-tooltip'),
          positionTooltip = $this.find('.js-tooltip').hasClass('js-bottom-tooltip'); // Покажывать ли тултип снизу вернет true / false

    setPositionTooltip($(this), tooltip, positionTooltip);
  });

  function setPositionTooltip(tooltipTrigger, tooltip, position) {
    // Если тулпит внизу
    if (position) {
      const positionBottom = tooltip.height() + 20
      tooltip.css('bottom',  -positionBottom);
    } else {
      const positionTop = tooltip.height() + 20
      tooltip.css('top',  -positionTop);
    }
  }

});